/* Prime Fire Pits — base JS. Scaffold; add real interactivity when the
 * product page sections are cloned in. */
(function () {
  'use strict';
  // No-op for now. This file exists so layout/theme.liquid can reference it
  // and the page can extend it later without re-deploying the layout.
})();
